import { render, staticRenderFns } from "./Synthese.vue?vue&type=template&id=673e6ffc&"
import script from "./Synthese.vue?vue&type=script&lang=js&"
export * from "./Synthese.vue?vue&type=script&lang=js&"
import style0 from "./Synthese.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports